import {createSelector} from 'reselect';

const getShoppingCart = (store) => store.shoppingCart.shoppingCart || {};
const getSegments = (store) => getShoppingCart(store).segments || [];
const existsEvolviCarrier = (shoppingCart) => shoppingCart.existsEvolviCarrier;
const existsDeutscheBahnCarrier = (shoppingCart) => shoppingCart.existsDeutscheBahnCarrier;
const getSegmentsFromShoppingCart = (shoppingCart) => shoppingCart.segments || [];
const getFreeCancellation = (shoppingCart) => shoppingCart.freeCancellationLimitDTO;

const trainSelector = (segments) => segments.some((segment) => segment.transportType === 'TRAIN');
const productSelector = (segments) => {
    const hasFlight = segments.some(({transportType}) => transportType === 'PLANE');
    const hasTrain = segments.some(({transportType}) => transportType === 'TRAIN');
    return hasFlight && hasTrain ? 'xfaring' : hasTrain ? 'train' : 'flight';
};
const getTripType = (segments) => {
    const sameOriginAndDestination = segments.length === 2 && segments[0].departureLocation.cityIataCode === segments[1].arrivalLocation.cityIataCode;
    let tripType;
    if (segments.length === 1) {
        tripType = 'ONE_WAY';
    } else if (sameOriginAndDestination) {
        tripType = 'ROUND_TRIP';
    } else {
        tripType = 'MULTIPLE_DESTINATIONS';
    }
    return tripType;
};

const getInsuranceShoppingItems = (shoppingCart) => {
    const otherProductShoppingItems = shoppingCart.otherProductsShoppingItems || {};
    return otherProductShoppingItems.insuranceShoppingItems || [];
};

const mapSegmentToIatas = (segments) => {
    return segments.reduce((acc, actual, index) => {
        const iata = {
            [`flight${index}`]: {
                departure: actual.departureLocation.iata,
                arrival: actual.arrivalLocation.iata,
            },
        };
        return Object.assign(acc, iata);
    }, {});
};

const hasTrainsSelector = createSelector(getSegments, trainSelector);
const productNameSelector = createSelector(getSegments, productSelector);
const existsEvolviCarrierSelector = createSelector(getShoppingCart, existsEvolviCarrier);
const existsDeutscheBahnCarrierSelector = createSelector(getShoppingCart, existsDeutscheBahnCarrier);
const segmentsSelector = createSelector(getShoppingCart, getSegmentsFromShoppingCart);
const tripIatas = createSelector(segmentsSelector, mapSegmentToIatas);
const freeCancellationSelector = createSelector(getShoppingCart, getFreeCancellation);
const tripTypeSelector = createSelector(getSegments, getTripType);
const insuranceShoppingItemsSelector = createSelector(getShoppingCart, getInsuranceShoppingItems);

export default {
    hasTrains: (store) => hasTrainsSelector(store),
    productName: (store) => productNameSelector(store),
    existsEvolviCarrier: (store) => existsEvolviCarrierSelector(store),
    existsDeutscheBahnCarrier: (store) => existsDeutscheBahnCarrierSelector(store),
    segments: (store) => segmentsSelector(store),
    tripType: (store) => tripTypeSelector(store),
    freeCancellation: (store) => freeCancellationSelector(store),
    tripIatas: (store) => tripIatas(store),
    insuranceShoppingItems: (store) => insuranceShoppingItemsSelector(store),
};
